export const opportunityInitialState = {
    opportunity: null,
    isLoading: true,
}